import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { TOK, SANS } from "../../components/soulumoCreate/shared";
import { API, auth, Dots, useVoice } from "../../components/soulumoDemo/DemoBits";
import { WelcomeStep, ChatStep, WordsStep, VoiceStep, MusicStep, BuildStep, ListenStep } from "../../components/soulumoDemo/DemoSteps";
import { DemoPaywall } from "../../components/soulumoDemo/DemoPaywall";
import { setVia, visitorId } from "../../lib/via";
import { useAuth } from "../../hooks/useAuth";

const STEPS = [WelcomeStep, ChatStep, WordsStep, VoiceStep, MusicStep, BuildStep, ListenStep];
const REASONS = { signature_limit: "You've chosen your 3 free signature installations. Join to unlock the whole library and create your own." };

// Guided demo: the real create journey with Andrew as the example, then "make it yours". Zero per-visitor cost.
export default function SoulumoDemoPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [demo, setDemo] = useState(null);
  const [step, setStep] = useState(params.get("step") === "pay" ? STEPS.length : 0);
  const voice = useVoice();
  const kind = params.get("kind") || undefined;
  const { user } = useAuth();
  const via = (params.get("via") || "").trim().toLowerCase();
  if (via && /^[a-z0-9-]{1,31}$/.test(via)) setVia(via);
  useEffect(() => { axios.get(`${API}/api/soulumo/demo`, { ...auth(), params: { kind } }).then((r) => setDemo(r.data)).catch(() => setDemo(false)); }, [kind]);
  const next = () => { voice.stop(); setStep((s) => s + 1); window.scrollTo({ top: 0 }); };
  useEffect(() => {
    const ev = step === 0 ? "start" : step === STEPS.length ? "paywall" : null;
    if (ev) axios.post(`${API}/api/soulumo/demo/event`, { event: ev, visitor_id: visitorId() }, auth()).catch(() => {});
  }, [step]);
  const Step = STEPS[step];
  return (
    <div className="min-h-screen px-5 pt-6 pb-16" style={{ background: "#0d1f3a" }} data-testid="soulumo-demo-page">
      <div className="mx-auto max-w-md">
        <div className="flex items-center justify-between mb-8">
          <button type="button" onClick={() => (step > 0 ? (voice.stop(), setStep(step - 1)) : nav(params.get("from") === "launch" ? "/soulumo/launch" : user ? "/my-journeys" : "/soulumo"))} data-testid="demo-back-btn"
            className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em]" style={{ color: TOK.creamDim, fontFamily: SANS }}><ArrowLeft size={14} /> Back</button>
          <Dots step={step} total={STEPS.length + 1} />
        </div>
        {demo === null && <Loader2 className="mx-auto mt-24 animate-spin" style={{ color: TOK.gold }} />}
        {demo === false && <p className="text-center mt-20" style={{ color: TOK.creamDim }}>The demo didn't load. Please refresh.</p>}
        {demo && (Step ? <Step demo={demo} line={demo.lines.welcome} voice={voice} onNext={next} />
          : <DemoPaywall reason={REASONS[params.get("reason")]} />)}
      </div>
    </div>
  );
}
